import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectiveRoute from "./protectiveRoute";
import Hello from './components/hello';
import Recharge from './components/recharge';
import Login from './components/login';
import Dashboard from './components/dashboard';
import SuperDmtTwo from './components/pages/superdmttwo';
import SuperDmtThree from './components/pages/superdmtthree';
import SecureMoneyTransfer from './components/pages/securemoneytransfer';
import BbpsOnline from './components/pages/bbpsonline';
import AepsNormalSettlement from './components/pages/aepsnormalsettlement';
import NewAeps from './components/pages/newaeps';
import WalletTransfer from './components/pages/wallettransfer';
import BbpsOffline from './components/pages/bbpsoffline';
// import KiaraBillPay from './components/pages/kiarabillpay';
import CreditCard from './components/pages/creditcard';
import Lpg from './components/pages/lpg';
import FundTransfer from './components/pages/fundtransfer';
import Lic from './components/pages/lic';
import Fastag from './components/pages/fastag';
import DMT from './components/pages/report/dmt';
import BBPS from './components/pages/report/bbps';
import VerificationReport from './components/pages/report/verificationreport';
import RechargeReport from "./components/pages/report/rechargereport";
import LicReport from "./components/pages/report/licreport";
import CmsReport from "./components/pages/report/cmsreport";
import AepsReport from "./components/pages/report/aepsreport";
import WalletToWalletReport from "./components/pages/report/wallettowalletreport";
import SettlementReport from "./components/pages/report/settlementreport";
import BillPaymentReport from "./components/pages/report/billpaymentreport";
import AccountStatementReport from "./components/pages/report/accountstatementreport";
import RefundPendigReport from "./components/pages/report/refundpendingreport";



function App() {
  return (
    <div className='App'>      
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Hello/>} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<ProtectiveRoute><Dashboard /></ProtectiveRoute>} />
          <Route path="/super-dmt-two" element={<ProtectiveRoute><SuperDmtTwo /></ProtectiveRoute>} />
          <Route path="/super-dmt-three" element={<ProtectiveRoute><SuperDmtThree /></ProtectiveRoute>} />
          <Route path="/secure-money-transfer" element={<ProtectiveRoute><SecureMoneyTransfer /></ProtectiveRoute>} />
          <Route path="/bill-pay" element={<ProtectiveRoute><BbpsOnline /></ProtectiveRoute>} />
          <Route path="/aeps-normal-settlement" element={<ProtectiveRoute><AepsNormalSettlement /></ProtectiveRoute>} />
          <Route path="/new-aeps" element={<ProtectiveRoute><NewAeps /></ProtectiveRoute>} />
          <Route path="/wallet-transfer" element={<ProtectiveRoute><WalletTransfer /></ProtectiveRoute>} />
          <Route path="/offline-pay" element={<ProtectiveRoute><BbpsOffline /></ProtectiveRoute>} />
          <Route path="/bill-pay" element={<ProtectiveRoute><BbpsOnline /></ProtectiveRoute>} />
          <Route path="/credit-card" element={<ProtectiveRoute><CreditCard /></ProtectiveRoute>} />
          <Route path="/lpg" element={<ProtectiveRoute><Lpg /></ProtectiveRoute>} />
          <Route path="/lic" element={<ProtectiveRoute><Lic /></ProtectiveRoute>} />
          <Route path="/fastag" element={<ProtectiveRoute><Fastag /></ProtectiveRoute>} />
          <Route path="/recharge" element={<ProtectiveRoute><Recharge /></ProtectiveRoute>} />
          <Route path="/recharge/:type" element={<ProtectiveRoute><Recharge /></ProtectiveRoute>} />
          <Route path="/fund-transfer" element={<ProtectiveRoute><FundTransfer /></ProtectiveRoute>} />
          <Route path="/dmt-report" element={<ProtectiveRoute><DMT /></ProtectiveRoute>} />
          <Route path="/bbps-report" element={<ProtectiveRoute><BBPS /></ProtectiveRoute>} />
          <Route path="/verification-report" element={<ProtectiveRoute><VerificationReport /></ProtectiveRoute>} />
          <Route path="/recharge-report" element={<ProtectiveRoute><RechargeReport /></ProtectiveRoute>} />
          <Route path="/lic-report" element={<ProtectiveRoute><LicReport /></ProtectiveRoute>} />
          <Route path="/cms-report" element={<ProtectiveRoute><CmsReport /></ProtectiveRoute>} />
          <Route path="/aeps-report" element={<ProtectiveRoute><AepsReport /></ProtectiveRoute>} />
          <Route path="/wallet-to-wallet-report" element={<ProtectiveRoute><WalletToWalletReport /></ProtectiveRoute>} />
          <Route path="/settlement-report" element={<ProtectiveRoute><SettlementReport /></ProtectiveRoute>} />
          <Route path="/billpayment-report" element={<ProtectiveRoute><BillPaymentReport /></ProtectiveRoute>} />
          <Route path="/account-statement-report" element={<ProtectiveRoute><AccountStatementReport /></ProtectiveRoute>} />
          <Route path="/refund-pending-report" element={<ProtectiveRoute><RefundPendigReport /></ProtectiveRoute>} />
          {/* <Route path="/user" element={<User />} /> */}
          {/* <Route path="*" element={<NoPage />} /> */}
        </Routes>
      </BrowserRouter>      
    </div>
  );
}

export default App;
